import React from 'react';
import Icon from '../../../components/AppIcon';

const ComingSoonSection = () => {
  const planned = [
    { icon: 'Gift', label: 'Rewards & Allowance', desc: 'Real-world rewards redeemable via Apple Pay, Google Pay, and more.', color: '#ff6b6b' },
    { icon: 'Calendar', label: 'Calendar & Events', desc: 'Shared family calendar with smart notifications.', color: '#ff6b6b' },
  ];

  return (
    <section className="py-24 relative overflow-hidden" style={{background: 'linear-gradient(160deg, #0f1f3d 0%, #1a3a5c 50%, #0f1f3d 100%)'}}>
      {/* Background effects */}
      <div className="absolute inset-0 opacity-[0.04]" style={{backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.8) 1px, transparent 1px)', backgroundSize: '28px 28px'}}></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full opacity-10 blur-3xl" style={{background: 'radial-gradient(ellipse, #f59e0b, transparent)'}}></div>
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6 px-5 py-2.5 rounded-full text-sm font-bold uppercase tracking-widest" style={{background: 'rgba(245,158,11,0.15)', color: '#f59e0b', border: '1px solid rgba(245,158,11,0.35)'}}>
            <Icon name="Sparkles" size={14} />
            Coming Soon
          </div>
          <h2 className="font-heading font-bold text-white leading-tight mb-5" style={{fontSize: 'clamp(2rem, 4vw, 3rem)'}}>
            More features are on the way.
          </h2>
          <p className="text-lg max-w-xl mx-auto" style={{color: 'rgba(255,255,255,0.6)'}}>
            We're building Cynizee one thoughtful feature at a time. Here's what's planned for future updates.
          </p>
        </div>

        {/* Feature grid — 2 columns centered */}
        <div className="grid sm:grid-cols-2 gap-4 mb-14 max-w-2xl mx-auto">
          {planned?.map((item, i) => (
            <div
              key={i}
              className="rounded-2xl p-6 flex flex-col gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl cursor-default group"
              style={{background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)'}}
            >
              <div className="flex items-center justify-between">
                <div className="w-11 h-11 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110" style={{background: `${item?.color}20`}}>
                  <Icon name={item?.icon} size={20} style={{color: item?.color}} />
                </div>
                <span className="text-xs font-bold px-2.5 py-1 rounded-full" style={{background: 'rgba(245,158,11,0.15)', color: '#f59e0b', border: '1px solid rgba(245,158,11,0.25)'}}>
                  Soon
                </span>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-white text-sm mb-1.5 leading-snug">{item?.label}</h3>
                <p className="text-xs leading-relaxed" style={{color: 'rgba(255,255,255,0.5)'}}>{item?.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <div className="inline-block rounded-3xl p-8 sm:p-10" style={{background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)'}}>
            <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5" style={{background: 'linear-gradient(135deg, #f59e0b, #d97706)'}}>
              <Icon name="Mail" size={28} className="text-white" />
            </div>
            <h3 className="font-heading font-bold text-white text-xl mb-2">Want to be notified when new features launch?</h3>
            <p className="mb-6" style={{color: 'rgba(255,255,255,0.5)'}}>Join the waitlist and be the first to know.</p>
            <a
              href="#hero"
              className="inline-flex items-center gap-2 font-heading font-bold px-8 py-4 rounded-2xl transition-all duration-300 hover:scale-105 hover:shadow-lg text-white"
              style={{background: 'linear-gradient(135deg, #ff6b6b, #ff4444)'}}
            >
              <Icon name="Bell" size={18} />
              Join the Waitlist
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoonSection;
